export default "__VITE_ASSET__DLUiy0jy__"